import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import DropdownNav from './DropdownNav'

const links = [
  { to: '/booking', label: 'Book a Room' },
  { to: '/members', label: 'Sign In' },
]

const dropdowns = [
  {
    label: 'Services',
    to: '/services',
    items: [
      { to: '/services/virtual-address',       label: 'Virtual Business Address', badge: 'Popular' },
      { to: '/services/professional-address', label: 'Professional Mailbox' },
      { to: '/services/part-time-office',      label: 'Part-Time Office Space' },
      { to: '/services/full-time-offices',     label: 'Full-Time Private Offices' },
      { to: '/services/conference-rooms',      label: 'Conference Rooms' },
    ],
  },
  {
    label: 'Resources',
    to: '/resources',
    items: [
      { to: '/resources/payments', label: 'Payments' },
      { to: '/resources/faqs',     label: 'FAQs' },
      { to: '/news/ecbcnews',      label: 'News' },
    ],
  },
]

const standaloneLinks = [
  { to: '/directory',      label: 'Directory' },
  { to: '/member-perks',   label: 'Member Perks' },
  { to: '/contact',        label: 'Contact Us' },
]

export default function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <nav className="bg-ecbc-navy text-white sticky top-0 z-50 shadow-lg">
      <div className="px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 leading-tight" onClick={() => setOpen(false)}>
          <picture>
            <source srcSet="/images/ECBC_logo_icon_sm.webp" type="image/webp" />
            <img
              src="/images/ECBC_logo_icon.png"
              alt="East County Business Center"
              className="h-12 w-auto"
              width="100"
              height="96"
            />
          </picture>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-5 text-sm font-medium">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              isActive
                ? 'text-ecbc-sky font-semibold border-b-2 border-ecbc-sky pb-0.5'
                : 'text-white/80 hover:text-ecbc-sky transition-colors duration-200'
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive
                ? 'text-ecbc-sky font-semibold border-b-2 border-ecbc-sky pb-0.5'
                : 'text-white/80 hover:text-ecbc-sky transition-colors duration-200'
            }
          >
            About Us
          </NavLink>

          {dropdowns.map((d) => (
            <DropdownNav key={d.label} {...d} />
          ))}

          {standaloneLinks.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                isActive
                  ? 'text-ecbc-sky font-semibold border-b-2 border-ecbc-sky pb-0.5'
                  : 'text-white/80 hover:text-ecbc-sky transition-colors duration-200'
              }
            >
              {label}
            </NavLink>
          ))}

          {links.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                isActive
                  ? 'text-ecbc-sky font-semibold border-b-2 border-ecbc-sky pb-0.5'
                  : 'text-white/80 hover:text-ecbc-sky transition-colors duration-200'
              }
            >
              {label}
            </NavLink>
          ))}

          <a
            href="tel:6194014000"
            className="hidden lg:inline text-white/60 hover:text-ecbc-sky transition-colors duration-200"
          >
            (619) 401-4000
          </a>

          <Link
            to="/signup"
            className="bg-ecbc-sky text-ecbc-navy font-bold px-4 py-1.5 rounded-md hover:bg-white transition-colors duration-200"
          >
            Sign Up
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-2 rounded-md text-white/80 hover:text-white"
          onClick={() => setOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {open ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-white/10 px-6 py-2 flex flex-col">
          <NavLink
            to="/"
            end
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `block py-2.5 ${isActive ? 'text-ecbc-sky font-semibold text-sm' : 'text-white/80 hover:text-ecbc-sky text-sm transition-colors'}`
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/about"
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `block py-2.5 ${isActive ? 'text-ecbc-sky font-semibold text-sm' : 'text-white/80 hover:text-ecbc-sky text-sm transition-colors'}`
            }
          >
            About Us
          </NavLink>

          {dropdowns.map((d) => (
            <DropdownNav key={d.label} {...d} isMobile onNavigate={() => setOpen(false)} />
          ))}

          {standaloneLinks.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block py-2.5 ${isActive ? 'text-ecbc-sky font-semibold text-sm' : 'text-white/80 hover:text-ecbc-sky text-sm transition-colors'}`
              }
            >
              {label}
            </NavLink>
          ))}

          {links.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block py-2.5 ${isActive ? 'text-ecbc-sky font-semibold text-sm' : 'text-white/80 hover:text-ecbc-sky text-sm transition-colors'}`
              }
            >
              {label}
            </NavLink>
          ))}

          <a href="tel:6194014000" className="block py-2.5 text-white/60 hover:text-ecbc-sky text-sm transition-colors">
            (619) 401-4000
          </a>

          <Link
            to="/signup"
            onClick={() => setOpen(false)}
            className="mt-2 bg-ecbc-sky text-ecbc-navy font-bold px-4 py-3 rounded-md text-sm text-center hover:bg-white transition-colors duration-200"
          >
            Sign Up
          </Link>
        </div>
      )}
    </nav>
  )
}
